import { useQuery } from "@tanstack/react-query";
import { salesDb } from "@/integrations/supabase/sales-client";
import { supabase } from "@/integrations/supabase/client";

export type BalanceRow = {
  fishsix_student_code: string;
  event_balance: number;
  first_name?: string | null;
  last_name?: string | null;
  nickname?: string | null;
};

export const useEventBalances = () => {
  return useQuery({
    queryKey: ["event-balances"],
    queryFn: async () => {
      const { data, error } = await salesDb()
        .from("v_student_event_balance")
        .select("fishsix_student_code,event_balance")
        .not("fishsix_student_code", "is", null)
        .gt("event_balance", 0);
      if (error) throw error;
      const rows = (data ?? []) as { fishsix_student_code: string; event_balance: number }[];
      const codes = rows.map((r) => r.fishsix_student_code);
      if (!codes.length) return [] as BalanceRow[];
      const { data: students } = await supabase
        .from("fishsix_students")
        .select("code,first_name,last_name,nickname")
        .in("code", codes);
      const m = new Map<string, any>();
      (students ?? []).forEach((s: any) => m.set(s.code, s));
      return rows
        .map((r) => ({
          ...r,
          first_name: m.get(r.fishsix_student_code)?.first_name ?? null,
          last_name: m.get(r.fishsix_student_code)?.last_name ?? null,
          nickname: m.get(r.fishsix_student_code)?.nickname ?? null,
        }))
        .sort((a, b) => b.event_balance - a.event_balance);
    },
  });
};
